/* undoToastStore.js — tiny pub/sub for the global UndoToast.
 *
 * One toast at a time, regardless of which row triggered it.
 * Components mount a single `<GlobalUndoToast />` near the App
 * root and call `showUndoToast({...})` from anywhere.
 */
import { useEffect, useState } from "react";

let _current = null;
const _listeners = new Set();

function _emit() {
  for (const fn of _listeners) fn(_current);
}

/**
 * Show the calm undo toast. Replaces any in-flight toast.
 *
 * @param {Object} cfg
 *   - label        — short operational sentence shown to the user
 *   - onUndo       — async function that performs the rollback
 *   - ttlMs        — optional override (default 5000ms)
 */
export function showUndoToast(cfg) {
  _current = { ...cfg, id: Date.now() };
  _emit();
}

export function dismissUndoToast() {
  _current = null;
  _emit();
}

export function useUndoToast() {
  const [state, setState] = useState(_current);
  useEffect(() => {
    _listeners.add(setState);
    return () => _listeners.delete(setState);
  }, []);
  return state;
}
